// extracted by mini-css-extract-plugin
module.exports = {"disabled":"style_disabled__1rOIHUWsLI_qI9eMEumiE-"};